const stats = [
  { value: '100+', label: 'Businesses Covered', icon: 'ri-building-2-line' },
  { value: 'All 50', label: 'States Served', icon: 'ri-map-pin-line' },
  { value: '50+', label: 'Direct Carrier Partners', icon: 'ri-shield-check-line' },
  { value: '120+', label: 'Broker Relationships', icon: 'ri-links-line' },
];

export default function StatsSection() {
  return (
    <section className="bg-[#111111] border-y border-[#c9a84c]/20 py-14">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8">
          {stats.map((stat, i) => (
            <div key={i} className={`flex flex-col items-center text-center ${i < stats.length - 1 ? 'lg:border-r lg:border-white/5' : ''}`}>
              <div className="w-10 h-10 flex items-center justify-center mb-3">
                <i className={`${stat.icon} text-[#D4AF37] text-2xl`} />
              </div>
              <span className="font-serif text-4xl text-[#D4AF37] font-bold mb-1">{stat.value}</span>
              <span className="text-white/40 text-sm font-sans uppercase tracking-wider">{stat.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
